export const ADVANCED_FILTERS_DEFAULT_COLLAPSE_NAME = 'filter';

export const isAdvancedFiltersCollapseOpen = (
	collapseState: unknown,
	collapseName: string = ADVANCED_FILTERS_DEFAULT_COLLAPSE_NAME
): boolean => {
	if (Array.isArray(collapseState)) {
		return collapseState.some((value) => String(value) === collapseName);
	}

	if (typeof collapseState === 'string' || typeof collapseState === 'number') {
		return String(collapseState) === collapseName;
	}

	return false;
};
